module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xNC4xNjY3IDBWMTEuODYyTDE3IDE0LjU2MlYwSDE0LjE2NjdaTTEuMjA4ODkgMS44TDAgMi45NDNMNy4zMDA1NSA5LjlINC43MjIyMlYxNi4ySDcuNTU1NTZWMTAuMTQzTDkuNDQ0NDQgMTEuOTQzVjE2LjJIMTIuMjc3OFYxNC42NDNMMTUuODAwNiAxOEwxNyAxNi44NDhMMS4yMDg4OSAxLjhaTTkuNDQ0NDQgNS40VjcuMzYyTDEyLjI3NzggMTAuMDYyVjUuNEg5LjQ0NDQ0Wk0wIDEzLjVWMTYuMkgyLjgzMzMzVjEzLjVIMFoiIGZpbGw9IiNBQ0FDQUMiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/noSign.svg
// module id = YE/l
// module chunks = 1